// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as SEOConstants$PorterinFeature from "../../../../shared/core/constants/SEOConstants.mjs";
import * as MediaEntityMapper$PorterinFeature from "../../../../shared/media/domain/entity-mappers/MediaEntityMapper.mjs";
import * as SharedEntityMapper$PorterinFeature from "../../../../shared/core/domain/entity-mappers/SharedEntityMapper.mjs";
import * as PartnersContentApiModel$PorterinFeature from "../api-model/PartnersContentApiModel.mjs";

function getTestimonialSection(model) {
  return {
          title: model.title,
          profiles: Js_array.map((function (profile) {
                  return {
                          name: profile.name,
                          city: profile.city,
                          image: MediaEntityMapper$PorterinFeature.getImage(profile.image),
                          description: profile.description
                        };
                }), model.profiles)
        };
}

function getPartnerOwnVihicle(model) {
  return {
          title: model.title,
          sub_title: model.sub_title,
          action: SharedEntityMapper$PorterinFeature.getLink(model.action),
          image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.image)
        };
}

function apiModelToState(model) {
  var data = model.data.attributes;
  return {
          hero_section: SharedEntityMapper$PorterinFeature.getHeroSection(data.hero_section),
          porter_advantage: SharedEntityMapper$PorterinFeature.getImageTitleDescContainer(data.porter_advantage),
          query_info: SharedEntityMapper$PorterinFeature.getImageTitleDesc(data.life_easy_section),
          additioanal_benifits: SharedEntityMapper$PorterinFeature.getImageTitleDescContainer(data.additioanal_benifits),
          testimonial_section: getTestimonialSection(data.testimonial_section),
          faq_section: SharedEntityMapper$PorterinFeature.getFaqsSection(data.faq_section),
          download_app: SharedEntityMapper$PorterinFeature.getImageTitleDesc(data.download_app),
          partner_own_vehicle: getPartnerOwnVihicle(data.partner_own_vehicle),
          meta_data: SharedEntityMapper$PorterinFeature.getMeta(data.meta_data, SEOConstants$PorterinFeature.defaultSeoTitleDesc.text, SEOConstants$PorterinFeature.defaultSeoTitleDesc.sub_text),
          get_partner_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta(data.get_partner_cta)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PartnersContentApiModel$PorterinFeature.t_decode(json), "PartnerDataEntityMapper.res"));
}

export {
  getTestimonialSection ,
  getPartnerOwnVihicle ,
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
